module.exports = __webpack_public_path__ + "static/media/19th-hole.c215e271.svg";